export default "__VITE_ASSET__CWIE8v5r__"